/*!

=========================================================
* Material Dashboard PRO React - v1.7.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";

import footerStyle from "assets/jss/material-dashboard-pro-react/components/footerStyle";

function Footer({ ...props }) {
  const { classes, fluid, white, rtlActive } = props;
  var container = cx({
    [classes.container]: !fluid,
    [classes.containerFluid]: fluid,
    [classes.whiteColor]: white
  });
  var anchor =
    classes.a +
    cx({
      [" " + classes.whiteColor]: white
    });
  var block = cx({
    [classes.block]: true,
    [classes.whiteColor]: white
  });
  return (
    <footer className={classes.footer}>
      <div className={container}>
        <div className={classes.left}>
          <List className={classes.list}>
            <ListItem className={classes.inlineBlock}>
              <a href="#home" className={block}>
                {"Home"}
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a href="http://careyou.org?ref=mdpr-footer" target="_new" className={block}>
                {"(주)캐어유"}
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a href="https://cafe.naver.com/lovecareyou/4" target="_new" className={block}>
                {"NAVER CAFE"}
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a href="/auth/terms" target="_new" className={block}>
                {"이용약관"}
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a href="/auth/privacy" target="_new" className={block}>
                {"개인정보처리방침"}
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a href="/auth/third-party-privacy" target="_new" className={block}>
                {"개인정보 제3자 제공 별도 동의"}
              </a>
            </ListItem>
          </List>
        </div>
        <p className={classes.right}>
          &copy;&nbsp; CareYou Co., Ltd.
        </p>
      </div>
    </footer>
  );
}

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
  fluid: PropTypes.bool,
  white: PropTypes.bool,
  rtlActive: PropTypes.bool
};

export default withStyles(footerStyle)(Footer);
